export default {
    COUNTRY: '@_get_finance_country',
    CITY: '@_get_finance_city',
    SELECT_COUNTRY: '@_select_finance_country',
    QUERY: '@_set_selected_filtraton',
};
